document.addEventListener('click', async function(e){
  const btn = e.target.closest('.bugs-rec-card__add');
  if(!btn) return;

  const variantId = btn.dataset.variantId;
  if(!variantId) return;

  btn.disabled = true;
  btn.classList.add('is-loading');
  btn.innerHTML = '…';

  try {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if(!addRes.ok) throw new Error();

    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    btn.innerHTML = '✓';

    const sectionRes = await fetch('/?sections=mini-cart');
    const sections = await sectionRes.json();

    if(sections['mini-cart']){
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['mini-cart'], 'text/html');
      const newMiniCart = doc.querySelector('#mini-cart');
      const currentMiniCart = document.querySelector('#mini-cart');

      if(newMiniCart && currentMiniCart){
        currentMiniCart.innerHTML = newMiniCart.innerHTML;
        currentMiniCart.setAttribute('open', '');
      }
    }
  } catch(error) {
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn.innerHTML = '＋';
    alert('追加できませんでした');
  }
});

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.bugs-rec-card__add').forEach(function(btn){
    btn.innerHTML = '＋';
    btn.setAttribute('aria-label', 'カートに追加');
  });
});